import React, { useEffect, useState } from "react";
import { TiSocialFacebook, TiSocialLinkedin } from "react-icons/ti";
import "./header.scss";

import { Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { AiFillCaretRight, AiFillInstagram } from "react-icons/ai";
import { useMediaQuery } from "react-responsive";
import { Link, NavLink } from "react-router-dom";
import MobileNav from "./MobileNav";
import SearchModal from "./searchModal";

function Navbar() {
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 800px)" });

	const [searchPopOverOpen, setSearchPopOverOpen] = useState(false);

	// Sticky Navbar
	const [scrolled, setScrolled] = useState(false);
	const [transition, setTransition] = useState("-70px");
	const handleScroll = () => {
		const offset = window.scrollY;
		if (offset > 200) {
			setScrolled(true);
			setTransition("0");
		} else {
			setScrolled(false);
			setTransition("-70px");
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
	});
	let navbarClasses = ["bottomNav sticky-top navbar navbar-expand-lg navbar-light"];
	if (scrolled) {
		navbarClasses.push("scrolled");
	}

	return (
		<div className="Navbar">
			{isTabletOrMobile ? (
				<MobileNav />
			) : (
				<div className="pcNav">
					<div className="topHeader">
						<div className="container">
							<div className="topHead row col-lg-12">
								<Link
									to="/"
									className="navLogo col-lg-6 col-md-6 col-sm-6 col-xs-12"
									style={{ textDecoration: "none" }}
								>
									<img
										alt="logo"
										className="logo"
										src={"https://res.cloudinary.com/ggi/image/upload/v1637903431/logo_ku2fnp.webp"}
									/>
									<h2>GGI</h2>
								</Link>

								<div className="socialButtonDiv col-lg-6 col-md-6 col-sm-6 col-xs-12">
									<a rel="noopener noreferrer"
										href="https://www.facebook.com/galaxygemologicalinstitute/"
										target="_blank"
										className="LinkSocial"
									>
										<button className="socialButton">
											<TiSocialFacebook />
										</button>
									</a>
									<a rel="noopener noreferrer"
										href="https://www.instagram.com/p/BwcEU31BmfU/?igshid=1qbzmi331ry43"
										target="_blank"
										className="LinkSocial"
									>
										<button className="socialButton">
											{" "}
											<AiFillInstagram />{" "}
										</button>
									</a>

									<a rel="noopener noreferrer"
										href="https://www.linkedin.com/posts/galaxy-gemological-institute_activity-6584389209035988992-SJjq/"
										target="_blank"
										className="LinkSocial"
									>
										<button className="socialButton">
											<TiSocialLinkedin />
										</button>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div>
						<nav id="navBar" className={navbarClasses.join(" ")} style={{ top: transition }}>
							<div className="container">
								<Link
									to="/"
									className="navLogoScroll"
									style={{ display: scrolled ? "flex" : "none", textDecoration: "none" }}
								>
									<img
										alt="logo"
										className="logo"
										src={"https://res.cloudinary.com/ggi/image/upload/v1637903431/logo_ku2fnp.webp"}
									/>
									<h2 style={{ color: "#FFF", fontSize: "40px", margin: "0 10px", fontFamily: "Bookman Old Style WGL", fontWeight: 600, letterSpacing: "2px" }}>GGI</h2>
								</Link>

								<div className="collapse navLinks navbar-collapse" id="navbarSupportedContent">
									<ul className="navbar-nav me-auto mb-2 mb-lg-0 ">
										<li className="nav-item">
											<NavLink
												exact
												activeClassName="active"
												to="/"
												className="nav-link"
												aria-current="page"
											>
												HOME
											</NavLink>
										</li>

										<li className="nav-item dropdown">
											<span
												activeClassName="active"
												className="nav-link "
												id=""
												data-bs-toggle="dropdow"
												aria-expanded="false"
											>
												SERVICES
											</span>
											<ul className="dropdown-menu drodpDownNav" aria-labelledby="navbarDropdown">
												<li className="nav-item Subdropdown">
													<NavLink
														activeClassName="active"
														to="/Laboratory"
														className="Subnav-link"
														id=""
														
														data-bs-toggle="dropdow"
														aria-expanded="false"
													>
														LABORATORY
														<AiFillCaretRight />
													</NavLink>
													<ul
														className="Subdropdown-menu SubdrodpDownNav"
														aria-labelledby="navbarDropdown"
													>
														<li>
															<NavLink activeClassName="active" to="/laboratory/about-ggi-laboratory">
																About GGI Laboratory
															</NavLink>
														</li>
														<li>
															<NavLink activeClassName="active" to="/laboratory/lab-reports">
																Lab Reports
															</NavLink>
														</li>
														<li>
															<NavLink activeClassName="active" to="/laboratory/lab-service-fee">
																Lab Service Fee
															</NavLink>
														</li>
														<li>
															<NavLink activeClassName="active" to="/laboratory/terms-and-conditions">
																Terms And Conditions
															</NavLink>
														</li>
													</ul>
												</li>
												<li className="nav-item Subdropdown">
													<NavLink
														activeClassName="active"
														to="/gemological-education"
														className="Subnav-link"
														id=""
														
														data-bs-toggle="dropdow"
														aria-expanded="false"
													>
														EDUCATION
														<AiFillCaretRight />
													</NavLink>
													<ul
														className="Subdropdown-menu SubdrodpDownNav"
														aria-labelledby="navbarDropdown"
													>
														<li>
															<NavLink activeClassName="active" to="/gemological-education">
																Gemological Education
															</NavLink>
														</li>
														<li>
															<NavLink activeClassName="active" to="/gemological-education/schedule">
																Course Schedule
															</NavLink>
														</li>
														<li>
															<NavLink activeClassName="active" to="/gemological-education/courses">
																Courses
															</NavLink>
														</li>
													</ul>
												</li>

												<li>
													<NavLink activeClassName="active" to="/appraisal">
														Appraisal
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="active" to="/gemology">
														Gemology
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="active" to="/gemology/YourBirthStone">
														Find Your Birth Stone
													</NavLink>
												</li>
											</ul>
										</li>

										<li className="nav-item dropdown">
											<NavLink
												activeClassName="active"
												to="/about"
												className="nav-link "
												id=""
												
												data-bs-toggle="dropdow"
												aria-expanded="false"
											>
												ABOUT US
											</NavLink>
											<ul className="dropdown-menu drodpDownNav" aria-labelledby="navbarDropdown">
												<li>
													<NavLink activeClassName="active" to="/about">
														Company
													</NavLink>
												</li>
												<li>
													<NavLink activeClassName="active" to="/about/found-and-ceo">
														Founder And CEO
													</NavLink>
												</li>
											</ul>
										</li>

										<li className="nav-item">
											<NavLink
												activeClassName="active"
												to="/contact-us"
												className="nav-link"
												tabIndex="-1"
											>
												CONTACT US
											</NavLink>
										</li>
									</ul>
								</div>
								<div className="navContact ScrollSearch">
									<Button
										onClick={() => {
											setSearchPopOverOpen(true);
										}}
										className="SearchButton"
									>
										Verify Your Report
									</Button>
									<Modal
										size="sm"
										dialogClassName="Model"
										style={{ top: scrolled ? "5%" : "15%" }}
										show={searchPopOverOpen}
										onHide={() => setSearchPopOverOpen(false)}
										aria-labelledby="example-modal-sizes-title-sm"
									>
										<Modal.Body>
											<SearchModal />
										</Modal.Body>
									</Modal>
								</div>
							</div>
						</nav>
					</div>
				</div>
			)}
			<div className="marqueeDiv">
				<marquee>
					<div className="newsDIv">
						<div className="liveIconDiv">
							<div className="liveIcon"></div>
						</div>
						Note: If you're unable to locate your certificate, please reach out to us for assistance. You can contact us at the following numbers: Karachi: <a href="tel:+92 (21) 3521-6044"> +92 (21) 3521-6044</a>, Peshawar: <a href="+92 (91) 256-8456"> +92 (91) 256-8456</a>.

					</div>
				</marquee>
			</div>
		</div>
	);
}

export default Navbar;
